export enum Role {
  Owner = 'owner',
  Editor = 'editor',
  Reviewer = 'reviewer',
  Viewer = 'viewer'
}
